<template>
    <div id="onboarding-layout">
        <template>   
            <b-col sm="12" align-v="center">
                <slot name="header"></slot>
            </b-col>

            <b-row class="vh-100" align-v="center">
                <b-col cols="12" md="10" offset-md="1" align-self="center" class="animated fadeIn">
                    
                    <transition 
                        name="slide"
                    >
                        <slot></slot>
                    </transition>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },

        onboardingSuccess: {
            type: Boolean,
            default: false
        }
    },

    data: function() {
        return {}
    },

    computed: {
    },

    methods: {
        async pauseOnboarding() {      
            this.$emit("pauseOnboarding")
        },
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/style.scss';
@import '@/assets/scss/_custom.scss';

#onboarding-layout {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1020;
    padding: 16px 24px;
    background: linear-gradient(135deg, $dark-hard-background 0%, $dark-background 100%);
    overflow-y: auto;
    overflow-x: hidden;
}
</style>